// extracted by mini-css-extract-plugin
export default {"inputsWrapper":"PurchasePage_inputsWrapper__1hfC2","separator":"PurchasePage_separator__ca1uW"};